var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Primer, } from '@primer-io/checkout-web';
import { Api } from './api';
import { v4 as uuidv4 } from 'uuid';
var ResponseError = /** @class */ (function (_super) {
    __extends(ResponseError, _super);
    function ResponseError(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
    }
    return ResponseError;
}(Error));
var PaymentSession = /** @class */ (function () {
    function PaymentSession(clientSetting, formSettings, api, checkoutTraceId) {
        this.clientSetting = clientSetting;
        this.formSettings = formSettings;
        this.api = api;
        this.checkoutTraceId = checkoutTraceId || null;
    }
    PaymentSession.prototype.prepareError = function (err, data) {
        if (err && err instanceof Error) {
            return {
                error: JSON.parse(JSON.stringify(err, Object.getOwnPropertyNames(err))),
                data: data,
            };
        }
        else {
            return { error: "Can't serialize error", data: data };
        }
    };
    PaymentSession.prototype.getTrace = function (headers) {
        return [
            headers.get('x-paltabrain-trace-id'),
            headers.get('x-paltabrain-request-id'),
        ];
    };
    PaymentSession.prototype.logErrorEvent = function (eventName, data, headers) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.logEvent('error', eventName, data, headers)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PaymentSession.prototype.notifyPaymentStatusChange = function (status, paymentMethodType) {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 5]);
                        if (!this.clientSetting.onPaymentStatusChange) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.clientSetting.onPaymentStatusChange(status, paymentMethodType)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        return [4 /*yield*/, this.logErrorEvent('on_payment_status_change_error', this.prepareError(err_1))];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    PaymentSession.prototype.notifyError = function (error, description) {
        return __awaiter(this, void 0, void 0, function () {
            var err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 5]);
                        if (!this.clientSetting.onError) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.clientSetting.onError(error, description)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [3 /*break*/, 5];
                    case 3:
                        err_2 = _a.sent();
                        return [4 /*yield*/, this.logErrorEvent('on_error', this.prepareError(err_2))];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    PaymentSession.prototype.onBeforePaymentCreate = function (data, handler) {
        return __awaiter(this, void 0, void 0, function () {
            var paymentMethodType, startCheckoutRequest, response, data_1, _a, traceId, requestId, statusCode, err_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        paymentMethodType = data.paymentMethodType;
                        return [4 /*yield*/, this.notifyPaymentStatusChange('PENDING', paymentMethodType)]; // send PENDING event to onPaymentStatusChange
                    case 1:
                        _b.sent(); // send PENDING event to onPaymentStatusChange
                        startCheckoutRequest = {
                            customerId: this.formSettings.customerId,
                            orderId: this.formSettings.orderId,
                            metadata: this.clientSetting.metadata,
                        };
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 10, , 14]);
                        return [4 /*yield*/, this.api.startCheckout(startCheckoutRequest)];
                    case 3:
                        response = _b.sent();
                        return [4 /*yield*/, response.json()];
                    case 4:
                        data_1 = _b.sent();
                        _a = this.getTrace(response.headers), traceId = _a[0], requestId = _a[1];
                        statusCode = data_1 === null || data_1 === void 0 ? void 0 : data_1.status;
                        if (!(statusCode == 'success')) return [3 /*break*/, 5];
                        // 2. continue payment creation
                        return [2 /*return*/, handler.continuePaymentCreation()];
                    case 5: return [4 /*yield*/, this.logErrorEvent('cant_start_checkout', this.prepareError(Error('cant_start_checkout'), {
                            paltabrain_trace_id: traceId,
                            paltabrain_request_id: requestId,
                            request: startCheckoutRequest,
                            response: data_1,
                        }))];
                    case 6:
                        _b.sent();
                        return [4 /*yield*/, this.notifyPaymentStatusChange('ERROR', paymentMethodType)]; // send ERROR event to onPaymentStatusChange
                    case 7:
                        _b.sent(); // send ERROR event to onPaymentStatusChange
                        return [4 /*yield*/, this.notifyError(new ResponseError(data_1), 'Can not start checkout')
                            // 3. abort payment creation
                        ];
                    case 8:
                        _b.sent();
                        // 3. abort payment creation
                        return [2 /*return*/, handler.abortPaymentCreation()];
                    case 9: return [3 /*break*/, 14];
                    case 10:
                        err_3 = _b.sent();
                        return [4 /*yield*/, this.logErrorEvent('cant_start_checkout', this.prepareError(err_3, { request: startCheckoutRequest }))];
                    case 11:
                        _b.sent();
                        return [4 /*yield*/, this.notifyPaymentStatusChange('ERROR', paymentMethodType)]; // send ERROR event to onPaymentStatusChange
                    case 12:
                        _b.sent(); // send ERROR event to onPaymentStatusChange
                        return [4 /*yield*/, this.notifyError(err_3, 'Can not start checkout')
                            // 3. abort payment creation
                        ];
                    case 13:
                        _b.sent();
                        // 3. abort payment creation
                        return [2 /*return*/, handler.abortPaymentCreation()];
                    case 14: return [2 /*return*/];
                }
            });
        });
    };
    PaymentSession.prototype.onCheckoutComplete = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var completeCheckoutRequest, paymentMethodType, rawResponse, response, status_1, _a, traceId, requestId, err_4;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        completeCheckoutRequest = {
                            orderId: this.formSettings.orderId,
                            paymentId: data.payment.id,
                        };
                        paymentMethodType = (_b = data.payment.paymentMethodData) === null || _b === void 0 ? void 0 : _b.paymentMethodType;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 10, , 14]);
                        return [4 /*yield*/, this.api.completeCheckout(completeCheckoutRequest)];
                    case 2:
                        rawResponse = _c.sent();
                        return [4 /*yield*/, rawResponse.json()];
                    case 3:
                        response = _c.sent();
                        status_1 = response === null || response === void 0 ? void 0 : response.status;
                        _a = this.getTrace(rawResponse.headers), traceId = _a[0], requestId = _a[1];
                        if (!(status_1 == 'success')) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.notifyPaymentStatusChange('COMPLETE', paymentMethodType)]; // send COMPLETE event to onPaymentStatusChange
                    case 4:
                        _c.sent(); // send COMPLETE event to onPaymentStatusChange
                        return [3 /*break*/, 9];
                    case 5: return [4 /*yield*/, this.notifyPaymentStatusChange('ERROR', paymentMethodType)]; // send ERROR event to onPaymentStatusChange
                    case 6:
                        _c.sent(); // send ERROR event to onPaymentStatusChange
                        return [4 /*yield*/, this.notifyError(new ResponseError(response), 'Can not complete checkout')];
                    case 7:
                        _c.sent();
                        return [4 /*yield*/, this.logErrorEvent('on_checkout_complete_error', this.prepareError(Error('on_checkout_complete_error'), {
                                paltabrain_trace_id: traceId,
                                paltabrain_request_id: requestId,
                                request: completeCheckoutRequest,
                                response: response,
                            }))];
                    case 8:
                        _c.sent();
                        _c.label = 9;
                    case 9: return [3 /*break*/, 14];
                    case 10:
                        err_4 = _c.sent();
                        return [4 /*yield*/, this.notifyPaymentStatusChange('ERROR', paymentMethodType)]; // send ERROR event to onPaymentStatusChange
                    case 11:
                        _c.sent(); // send ERROR event to onPaymentStatusChange
                        return [4 /*yield*/, this.notifyError(err_4, 'Can not complete checkout')];
                    case 12:
                        _c.sent();
                        return [4 /*yield*/, this.logErrorEvent('on_checkout_complete_error', this.prepareError(err_4, {
                                request: completeCheckoutRequest,
                                response: data,
                            }))];
                    case 13:
                        _c.sent();
                        return [3 /*break*/, 14];
                    case 14: return [2 /*return*/];
                }
            });
        });
    };
    PaymentSession.prototype.onCheckoutFail = function (error, data, handler) {
        return __awaiter(this, void 0, void 0, function () {
            var failCheckoutRequest, paymentMethodType, err_5;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        failCheckoutRequest = {
                            orderId: this.formSettings.orderId,
                            paymentId: (_a = data.payment) === null || _a === void 0 ? void 0 : _a.id,
                        };
                        paymentMethodType = (_c = (_b = data.payment) === null || _b === void 0 ? void 0 : _b.paymentMethodData) === null || _c === void 0 ? void 0 : _c.paymentMethodType;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 5, , 7]);
                        return [4 /*yield*/, this.api.failCheckout(failCheckoutRequest)];
                    case 2:
                        _d.sent();
                        return [4 /*yield*/, this.notifyPaymentStatusChange('FAIL', paymentMethodType)]; // send FAIL event to onPaymentStatusChange
                    case 3:
                        _d.sent(); // send FAIL event to onPaymentStatusChange
                        return [4 /*yield*/, this.notifyError(error, 'Checkout failed')];
                    case 4:
                        _d.sent();
                        return [3 /*break*/, 7];
                    case 5:
                        err_5 = _d.sent();
                        return [4 /*yield*/, this.logErrorEvent('on_checkout_fail_error', this.prepareError(err_5, __assign({}, failCheckoutRequest)))];
                    case 6:
                        _d.sent();
                        return [3 /*break*/, 7];
                    case 7:
                        if (!handler) {
                            return [2 /*return*/];
                        }
                        return [2 /*return*/, handler.showErrorMessage()];
                }
            });
        });
    };
    return PaymentSession;
}());
export { PaymentSession };
var PaymentClientImpl = /** @class */ (function () {
    function PaymentClientImpl(settings, customerId) {
        this.clientSettings = settings;
        this.customerId = customerId;
        this.api = new Api(settings);
        this.clientToken = null;
        this.checkout = null;
        this.reCaptchaReady = false;
        this.checkoutTraceId = null;
    }
    PaymentClientImpl.prototype.generateCheckoutTraceId = function () {
        this.checkoutTraceId = uuidv4();
    };
    PaymentClientImpl.prototype.loadReCaptchaScript = function (onReCaptchaReady, onError) {
        var _this = this;
        // Check if reCAPTCHA is already loaded
        if (window.grecaptcha) {
            console.log('reCAPTCHA already loaded');
            if (onError) {
                onError();
            }
            return;
        }
        var siteKey = this.clientSettings.reCaptchaSiteKey;
        if (!siteKey) {
            console.warn('reCapchaSiteKey is not set');
            if (onError) {
                onError();
            }
            return;
        }
        var script = document.createElement('script');
        script.src = "https://www.google.com/recaptcha/enterprise.js?render=".concat(siteKey);
        script.async = true;
        script.onerror = function () {
            console.warn('Failed to load reCAPTCHA script');
            if (onError) {
                onError();
            }
        };
        script.onload = function () {
            if (!grecaptcha) {
                if (onError) {
                    onError();
                }
                return;
            }
            grecaptcha.enterprise.ready(function () {
                _this.reCaptchaReady = true;
                if (onReCaptchaReady) {
                    onReCaptchaReady();
                }
            });
        };
        document.head.appendChild(script);
    };
    PaymentClientImpl.prototype.generateReCaptchaToken = function (siteKey) {
        return __awaiter(this, void 0, void 0, function () {
            var token, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, grecaptcha.enterprise.execute(siteKey, {
                                action: 'create_client_session',
                            })];
                    case 1:
                        token = _a.sent();
                        return [2 /*return*/, token];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Failed to generate reCAPTCHA token:', error_1);
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PaymentClientImpl.prototype.getPricePoints = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var resp, result, pricePoints, _i, pricePoints_1, pricePoint;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.getPricePoints(request)];
                    case 1:
                        resp = _a.sent();
                        return [4 /*yield*/, resp.json()];
                    case 2:
                        result = _a.sent();
                        pricePoints = result['pricePoints'];
                        for (_i = 0, pricePoints_1 = pricePoints; _i < pricePoints_1.length; _i++) {
                            pricePoint = pricePoints_1[_i];
                            pricePoint['product'] = result['products'][pricePoint.productSku];
                        }
                        return [2 /*return*/, pricePoints];
                }
            });
        });
    };
    PaymentClientImpl.prototype.showPaymentForm = function (settings, options, clientToken) {
        return __awaiter(this, void 0, void 0, function () {
            var recaptchaToken, resp, result, session, checkoutOptions, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.generateCheckoutTraceId();
                        this.api.setHeaders({ 'x-checkout-trace-id': this.checkoutTraceId || '' });
                        recaptchaToken = null;
                        if (!(this.clientSettings.reCaptchaEnabled &&
                            this.clientSettings.reCaptchaSiteKey &&
                            this.reCaptchaReady)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.generateReCaptchaToken(this.clientSettings.reCaptchaSiteKey)];
                    case 1:
                        recaptchaToken = _b.sent();
                        _b.label = 2;
                    case 2:
                        if (!!clientToken) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.api.createClientSession({
                                customerId: settings.customerId,
                                orderId: settings.orderId,
                                ident: settings.ident,
                                countryCode: settings.countryCode,
                                platformCode: settings.platformCode,
                                metadata: this.clientSettings.metadata,
                                customer: settings.customer,
                                recaptchaToken: recaptchaToken,
                            })];
                    case 3:
                        resp = _b.sent();
                        return [4 /*yield*/, resp.json()];
                    case 4:
                        result = _b.sent();
                        clientToken = result.clientSession.clientToken;
                        _b.label = 5;
                    case 5:
                        this.clientToken = clientToken;
                        session = new PaymentSession(this.clientSettings, settings, this.api);
                        checkoutOptions = __assign(__assign({}, options), { onBeforePaymentCreate: session.onBeforePaymentCreate.bind(session), onCheckoutComplete: session.onCheckoutComplete.bind(session), onCheckoutFail: session.onCheckoutFail.bind(session) });
                        if (!clientToken) return [3 /*break*/, 7];
                        _a = this;
                        return [4 /*yield*/, Primer.showUniversalCheckout(clientToken, checkoutOptions)];
                    case 6:
                        _a.checkout = _b.sent();
                        return [2 /*return*/, this.checkout];
                    case 7:
                        console.log('clientToken is empty');
                        _b.label = 8;
                    case 8: return [2 /*return*/, null];
                }
            });
        });
    };
    PaymentClientImpl.prototype.updatePaymentForm = function (settings) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.api.updateClientSession({
                            customerId: settings.customerId,
                            orderId: settings.orderId,
                            ident: settings.ident,
                            countryCode: settings.countryCode,
                            platformCode: settings.platformCode,
                            metadata: this.clientSettings.metadata,
                            customer: settings.customer,
                            clientToken: this.clientToken,
                        })];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, ((_a = this.checkout) === null || _a === void 0 ? void 0 : _a.refreshClientSession())];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return PaymentClientImpl;
}());
export function createPaymentClient(init, customerId) {
    if (customerId === void 0) { customerId = null; }
    return new PaymentClientImpl(init, customerId);
}
